import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';

import './App.css';

import Main from './pages/Main';
import Author from './pages/Author';
import Authors from './pages/Authors';
import Piece from './pages/Piece';
import PAGES from './lib/pages';
import PageNotFound from './pages/PageNotFound';
import Books from './pages/Books';
import About from './pages/About';
import Issues from './pages/Issues';
import { DataContext } from './contexts/DataContext';
import Issue from './pages/Issue';
import { HelmetProvider } from 'react-helmet-async';
const Admin = React.lazy(() => import('./pages/Admin'));

const routes = {
  authors: 
    <>
      <Route path={PAGES.authors} element={<Authors />} />
      <Route path={PAGES.author} element={<Author />} />
    </>,
  issues:
    <>
      <Route path={PAGES.issues} element={<Issues />} />
    </>,
  books:
    <>
      <Route path={PAGES.books} element={<Books />} />
    </>,
  contacts:
    <>
      <Route path={PAGES.contacts} element={<About />} />
    </>,
};

function App() {
  const { menuPages } = useContext(DataContext);

  const visibleRoutes = []
  menuPages.forEach(page => {
    if (routes[page.title]) {
      visibleRoutes.push(routes[page.title]);
    }
  })
  menuPages.sort((a, b) => a.display_order - b.display_order);

    
  return (
    <div className="App">
      <HelmetProvider>
        <Routes>
          <Route path={PAGES.main} element={<Main isMain />} />
          <Route path={PAGES.issue} element={<Issue />} />
          <Route path={PAGES.piece} element={<Piece />} />
          <Route path={PAGES.draft} element={<Piece isDraft />} />
          
          {visibleRoutes}

          <Route
            path={PAGES.admin}
            element={
              <React.Suspense
              fallback={null}>
                <Admin />
              </React.Suspense>
            } />
          <Route path='*' element={<PageNotFound />} />
        </Routes>
      </HelmetProvider>
    </div>
  );
}

export default App;
